// extracted by mini-css-extract-plugin
export var dropdownContainer = "_om-0";
export var leftAlign = "_om-4";
export var listItem = "_om-2";
export var listItemWrapper = "_om-1";
export var operationText = "_om-3";